import React from "react";
import InputItem from './InputItem'
import MoneyInputCon from '$Deposits/Components/Components/MoneyInput'
import TipsView from './TipsView'
import { numberWithCommas } from '$Deposits/lib/LibCommonData'

class MoneyInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {


        return (
            <>
                <MoneyInputCon
                    MoneyInput={(propCon) => {
                        const {
                            title,
                            stateVal,
                            value,
                            placeholder,
                            onChange,
                            MethodCodeActive,
                            // InvoiceExchangerate
                        } = propCon
                        return (
                            <>
                                <InputItem
                                    title={title}
                                    stateVal={stateVal}
                                    value={value}
                                    placeholder={placeholder}
                                    onChange={onChange}
                                    MethodCodeActive={MethodCodeActive}
                                    // InvoiceExchangerate={InvoiceExchangerate}
                                />
                                {
                                    // MethodCodeActive == 'INVOICE' && <b className="blueTip">={numberWithCommas(value && (value * 1000))} VND</b>
                                }
                            </>
                        )
                    }}
                    PHCMoneyInput={(propCon) => {
                        const {
                            title,
                            SuggestedAmounts,
                            value,
                            chargesMoney,
                            onChange,
                        } = propCon
                        return (
                            <>
                                <p className="inputTitle">{title}</p>
                                <div className="PHC-amounts">
                                    {
                                        SuggestedAmounts.map((item, index) => {
                                            return (
                                                <div
                                                    key={index}
                                                    className="PHC-amountList"
                                                    onClick={() => { onChange(item) }}
                                                >
                                                    <div className={item == value ? 'activeSelect' : 'borderSelect'} />
                                                    <p>{item != '' && numberWithCommas(item * 1000)} VND</p>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                {
                                    chargesMoney ?
                                        <div className="phc-chargesMoney">
                                            <TipsView msg={'Hãy chắc chắn bạn chọn đúng mệnh giá, vì nếu chọn nhầm mệnh giá thấp hơn giá trị của thẻ thì Bạn sẽ không được hoàn lại số tiền còn lại'} />
                                            <div className="phc-amount-conversion">
                                                <span>Số Tiền Gửi Thực Tế</span>
                                                <span>{chargesMoney} đ</span>
                                            </div>
                                            <p className="chargesMoney">= {numberWithCommas(chargesMoney * 1000)}VND</p>
                                        </div>
                                        : <></>
                                }

                            </>
                        )
                    }}
                />
            </>
        );
    }
}

export default MoneyInput




